import { Form, Input, message, Spin } from "antd";
import React, { Component } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { PageTitle, FormBtn, RequriedText } from "lib/widget";

const FormItem = Form.Item;

export default class ServiceTypeForm extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const { errorMessage, alertMessage } = nextProps;

    if (alertMessage !== "") {
      return { alertMessage: alertMessage };
    }

    if (errorMessage !== "") {
      return { errorMessage: errorMessage };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    const { errorMessage, alertMessage } = this.props;
    const prevMsg = prevProps;

    if (errorMessage !== "" && prevMsg.errorMessage !== errorMessage) {
      message.error(errorMessage);
    }

    if (alertMessage !== "" && prevMsg.alertMessage !== alertMessage) {
      message.success(alertMessage);
    }
  }

  componentDidMount() {
    this.nameInput.focus();
  }
  isDisabled = () => {
    return (
      this.props.serviceType.actual_service_type_code !== "" &&
      this.props.editCode
    );
  };

  render() {
    const { serviceType, onSubmit } = this.props;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
      }
    };

    return (
      <div>
        <Spin size="large" spinning={this.props.loading}>
          <PageTitle name="actual_service_types" component={null} />
          <Formik
            initialValues={serviceType}
            enableReinitialize={true}
            validationSchema={yup.object().shape({
              actual_service_type_code: yup
                .string()
                .required("Code is a required field"),
              actual_service_type: yup
                .string()
                .required("Name is a required field"),
              actual_service_type_abbr: yup
                .string()
                .nullable()
                .required("Abbr. is a required field")
            })}
            onSubmit={values => onSubmit(values)}
            render={({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit
            }) => (
              <Form onFinish={handleSubmit} autoComplete="off">
                <fieldset disabled={!this.props.canEdit}>
                  <FormItem
                    {...formItemLayout}
                    label={<RequriedText label="Code" />}
                    validateStatus={
                      touched.actual_service_type_code &&
                      errors.actual_service_type_code &&
                      "error"
                    }
                    help={
                      touched.actual_service_type_code &&
                      errors.actual_service_type_code
                    }
                  >
                    <Input
                      ref={input => {
                        this.nameInput = input;
                      }}
                      name="actual_service_type_code"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.actual_service_type_code}
                      disabled={this.isDisabled()}
                    />
                  </FormItem>
                  <FormItem
                    {...formItemLayout}
                    label={<RequriedText label="Name" />}
                    validateStatus={
                      touched.actual_service_type &&
                      errors.actual_service_type &&
                      "error"
                    }
                    help={
                      touched.actual_service_type && errors.actual_service_type
                    }
                  >
                    <Input
                      name="actual_service_type"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.actual_service_type}
                    />
                  </FormItem>
                  <FormItem
                    {...formItemLayout}
                    label={<RequriedText label="Abbr." />}
                    validateStatus={
                      touched.actual_service_type_abbr &&
                      errors.actual_service_type_abbr &&
                      "error"
                    }
                    help={
                      touched.actual_service_type_abbr &&
                      errors.actual_service_type_abbr
                    }
                  >
                    <Input
                      name="actual_service_type_abbr"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.actual_service_type_abbr}
                    />
                  </FormItem>
                  <FormBtn
                    url="/actual-service/types"
                    canEdit={this.props.canEdit}
                  />
                </fieldset>
              </Form>
            )}
          />
        </Spin>
      </div>
    );
  }
}
